import gql from 'graphql-tag';

import { PhotoThumbnails } from './album';
import { AlbumFolderTagDetails } from './album-folder-tags';

export const AlbumMembershipsBasic = gql`
  fragment AlbumMembershipsBasic on Account {
    album_memberships(with_paid: true) {
      records {
        id
        album {
          id
        }
      }
    }
  }
`;

export const AlbumMembershipsWithAlbum = gql`
  fragment AlbumMembershipsWithAlbum on Account {
    album_memberships(album_id: $albumId) {
      records {
        id
        album {
          id
        }
      }
    }
  }
`;

export const AlbumMembershipsWithAlbumAndPurchasedIdentities = gql`
  fragment AlbumMembershipsWithAlbumAndPurchasedIdentities on Account {
    album_memberships(album_id: $albumId) {
      records {
        id
        album {
          id
          name
        }
        selected_identities(claimed_status_filter: CLAIMED) {
          records {
            id
            identity {
              id
            }
          }
        }
        purchased_identities {
          records {
            id
          }
        }
      }
    }
  }
`;

export const AlbumMembershipsWithAlbumAndPurchasedPhotos = gql`
  fragment AlbumMembershipsWithAlbumAndPurchasedPhotos on Account {
    album_memberships(album_id: $albumId) {
      records {
        id
        album {
          id
        }
        purchased_photos(slice: { limit: 999 }) {
          records {
            id
          }
        }
        matched_photos_extended(slice: { limit: 999 }) {
          records {
            photo {
              id
            }
          }
        }
        entitled_matched_photos(slice: { limit: 999 }) {
          records {
            id
          }
        }
      }
    }
  }
`;

export const AlbumMembershipsWithAlbumAndEntitledPhotos = gql`
  fragment AlbumMembershipsWithAlbumAndEntitledPhotos on Account {
    album_memberships(album_id: $albumId) {
      records {
        id
        has_all_photos_access
        album {
          id
          name
          display_name
        }
        entitled_matched_photos(slice: { limit: 999 }) {
          total
          records {
            ...PhotoThumbnails
          }
        }
        matched_photos {
          total
        }
      }
    }
  }
  ${PhotoThumbnails}
`;

export const AlbumMembershipsWithAlbumAndEntitledPhotosPerIdentity = gql`
  fragment AlbumMembershipsWithAlbumAndEntitledPhotosPerIdentity on Account {
    id
    album_memberships(album_id: $albumId) {
      records {
        id
        has_all_photos_access
        album {
          id
          name
          display_name
        }
        selected_identities {
          records {
            id
            identity {
              id
              name
              current_photo {
                ...PhotoThumbnails
              }
            }
            entitled_matched_photos(slice: { limit: 999 }) {
              total
              records {
                id
                ...PhotoThumbnails
              }
            }
            matched_photos {
              total
            }
          }
        }
      }
    }
  }
  ${PhotoThumbnails}
`;

export const AlbumMembershipsWithAlbumAndMatchedPhotosPerIdentity = gql`
  fragment AlbumMembershipsWithAlbumAndMatchedPhotosPerIdentity on Account {
    id
    album_memberships(album_id: $albumId) {
      records {
        id
        has_all_photos_access
        album {
          id
          name
          display_name
        }
        matched_photos(slice: { limit: 999 }) {
          total
        }
        entitled_matched_photos(slice: { limit: 999 }) {
          total
          records {
            id
          }
        }
        selected_identities(
          slice: { limit: 999 }
          claimed_status_filter: CLAIMED
        ) {
          records {
            id
            identity {
              id
              name
              current_photo {
                ...PhotoThumbnails
              }
            }
            matched_photos_extended(slice: { limit: 999 }) {
              total
              records {
                id
                photo {
                  ...PhotoThumbnails
                  price_album_folder_tag(album_id: $albumId) {
                    ...AlbumFolderTagDetails
                  }
                }
                compared_face {
                  facebox
                }
                identity {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  ${PhotoThumbnails}
  ${AlbumFolderTagDetails}
`;

export const AlbumMembershipsWithAlbumAndPhotosTotals = gql`
  fragment AlbumMembershipsWithAlbumAndPhotosTotals on Account {
    album_memberships(with_paid: true) {
      records {
        id
        album {
          id
          name
          display_name
          root_album_folder {
            id
            price {
              value
              currency
            }
            join_without_purchase
            album_price_mode
            album_delivery_modes {
              photo_finder
              shutterbug
            }
            individual_albums
          }
        }
        entitled_matched_photos {
          total
        }
        matched_photos_extended {
          total
        }
      }
    }
  }
`;
